import { render, staticRenderFns } from "./PlusBlue.vue?vue&type=template&id=09835f8c"
import script from "./PlusBlue.vue?vue&type=script&lang=js"
export * from "./PlusBlue.vue?vue&type=script&lang=js"
import style0 from "./PlusBlue.vue?vue&type=style&index=0&id=09835f8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports